// Client lib imports
const businessEvents = require('client/lib/business-events')

const SHOW = 'AUTH_MODAL_SHOW'
const HIDE = 'AUTH_MODAL_HIDE'

function show(hasAccount) {
  businessEvents.trackSegment('auth-login-modal', {
    hasAccount
  })
  return {
    type: SHOW,
    payload: { hasAccount }
  }
}

function showLogin() {
  return show(true)
}

function showSignup() {
  return show(false)
}

function showSULogin() {
  return socialAuth('stumbleupon', true)
}

function hide() {
  return {
    type: HIDE
  }
}

function socialAuth(provider, hasAccount) {
  return async function () {
    // Wait for tracking before navigating away from page
    await businessEvents.trackSegment('social-auth', {
      authContext: 'login-modal',
      hasAccount,
      provider
    })
    const r = encodeURIComponent(location.pathname + location.search)
    location.assign(`/auth/${provider}?r=${r}`)
  }
}

module.exports = {
  SHOW,
  HIDE,
  show,
  showLogin,
  showSignup,
  showSULogin,
  hide,
  socialAuth
}
